(() => {
  const header = document.querySelector('[data-bm-header]');
  if (!header) return;

  const toggle = header.querySelector('.bm-menu-toggle');
  const menu = header.querySelector('.bm-mobile-menu');
  const label = toggle?.querySelector('.visually-hidden');

  const setMenu = (open) => {
    if (!toggle || !menu) return;
    toggle.setAttribute('aria-expanded', String(open));
    menu.hidden = !open;
    header.classList.toggle('bm-site-header--menu-open', open);
    document.documentElement.classList.toggle('bm-menu-lock', open);
    if (label) label.textContent = open ? 'Menu sluiten' : 'Menu openen';
  };

  const syncHeader = () => {
    header.classList.toggle('bm-site-header--scrolled', window.scrollY > 18);
  };

  toggle?.addEventListener('click', () => {
    setMenu(toggle.getAttribute('aria-expanded') !== 'true');
  });

  menu?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenu(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  window.addEventListener('scroll', syncHeader, { passive: true });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 989) setMenu(false);
  });
  syncHeader();
})();
